import { ComponentType } from '@angular/cdk/overlay';
import { Component, OnInit, OnDestroy, ViewChild, Inject, ElementRef, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Params } from '@angular/router';
import { PaidLessonAuditComponent } from '../../audit/paid-lesson-audit/paid-lesson-audit.component';
import { BaseDialogComponent } from '../../forms/base-dialog/base-dialog.component';
import { EnrollmentEntityComponent } from '../../forms/enrollment-entity/enrollment-entity.component';
import { EventLessonEntityComponent } from '../../forms/event-lesson-entity/event-lesson-entity.component';
import { EventServicesEntityComponent } from '../../forms/event-services-entity/event-services-entity.component';
import { InquiryComponent } from '../../forms/inquiry/inquiry.component';
import { SetOpeningBalanceComponent } from '../../forms/set-opening-balance/set-opening-balance.component';
import { StudentDepartmentComponent } from '../../forms/student-department/student-department.component';
import { StudentInquiryDetailsComponent } from '../../forms/student-inquiry-details/student-inquiry-details.component';
import { StudentInquiryEntityComponent } from '../../forms/student-inquiry-entity/student-inquiry-entity.component';
import { StudentRecordEntityComponent } from '../../forms/student-record-entity/student-record-entity.component';
import { PaymentReportsComponent } from '../student-dashboard/tables/payment-reports/payment-reports.component';
import { PrintService } from 'src/app/services/print.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FieldsService } from 'src/app/services/fields.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { UserService } from 'src/app/services/user.service';
import { RefreshService } from 'src/app/services/refresh.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { PhoneNumberService } from 'src/app/services/phone-number.service';
import { ReportDateService } from 'src/app/services/report-date.service';
import { CurrencyService } from '../../../services/currency.service';
import { StudioTaxService, StudioTaxMode } from '../../../services/studio-tax.service';
import tippy from 'tippy.js';
import moment from 'moment';
import { Subscription, Observable, tap, delay, switchMap, of, shareReplay } from 'rxjs';
import { EventEmitter } from '@angular/core';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-student-dashboard-wrapper',
  templateUrl: './student-dashboard-wrapper.component.html',
  styleUrls: ['./student-dashboard-wrapper.component.css']
})
export class StudentDashboardWrapperComponent extends BaseDialogComponent implements OnInit, OnDestroy {

  constructor(
    public override _dialogRef: MatDialogRef<unknown>,
    public override _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public override _injectedDialogData: any,
    public override _refreshService: RefreshService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService,
    public override phoneNumberService: PhoneNumberService,
    public reportDateService: ReportDateService,
    private printService: PrintService,
    private currencyService: CurrencyService,
    private studioTaxService: StudioTaxService
  ) {
    super(
      _dialogRef,
      _dialog,
      _injectedDialogData,
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService,
      phoneNumberService
    );
  }

  // Modals to load.
  InquiryComponent = InquiryComponent;
  EventServicesEntityComponent = EventServicesEntityComponent;
  EventLessonEntityComponent = EventLessonEntityComponent;
  StudentInquiryEntityComponent = StudentInquiryEntityComponent;
  EnrollmentEntityComponent = EnrollmentEntityComponent;
  StudentRecordEntityComponent = StudentRecordEntityComponent;
  SetOpeningBalanceComponent = SetOpeningBalanceComponent;
  StudentDepartmentComponent = StudentDepartmentComponent;
  StudentInquiryDetailsComponent = StudentInquiryDetailsComponent;
  PaidLessonAuditComponent = PaidLessonAuditComponent;

  routeParams: any = {};
  sortParams: any = {};

  lessonStatuses: any[] = [];
  enrollmentBalance: any;

  user: { id: number }
  studentDashboardData: any;
  studentServices: any;
  studentServicesColumns: any;
  studentServicesRows: any;
  lessonListRows: any;
  lessonList2Rows: any;
  lessonListColumns: string[] = ['date', 'service', 'length', 'teacher', 'status', 'contacts_present', 'taken / rem', 'edit'];
  lessonList: any;
  studentAccountID;
  studentDashboardObservable: Observable<any>;
  dataSource: Object;
  currentEnrollment: any;
  overallEnrollmentBalance: any;
  nextLessonScheduled: any;
  studentBadgeInfo: any;
  legacyData: any;
  lessonBlockData: MatTableDataSource<any> = new MatTableDataSource([]);
  lessonBlockColumns: string[] = ['date', 'instructor_name', 'material_covered', 'comments', 'lesson_rating'];
  lessonBlockCurrentPage: number = 0;
  lessonBlockPageSize: number = 10;
  lessonBlockTotalCount: number = 0;
  lessonBlockHasMore: boolean = false;
  lessonBlockStartFromComment: boolean = true;
  private tippyInstances: any[] = [];
  private subscriptions: Subscription[] = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  // Only the active tab is rendered, so the Lesson List's MatSort is recreated
  // each time that tab is shown; re-attach it to the data sources when it changes.
  private _sort: MatSort;
  @ViewChild(MatSort) set sort(sort: MatSort) {
    this._sort = sort;
    if (this.lessonListRows) this.lessonListRows.sort = sort;
    if (this.lessonList2Rows) this.lessonList2Rows.sort = sort;
  }
  get sort(): MatSort {
    return this._sort;
  }
  @ViewChild(PaymentReportsComponent) paymentReportsComponent: PaymentReportsComponent;

  // The balance row is gated on the balance payloads, so the Payment Due label
  // renders after the request callback returns; attach the popover when the
  // element actually exists instead of querying for it from the callback.
  @ViewChild('paymentDueLabel') set paymentDueLabel(ref: ElementRef<HTMLElement> | undefined) {
    this.destroyTippyInstances();
    if (ref) {
      this.initializeTippy(ref.nativeElement);
    }
  }
  paymentReportColumns: string[];
  selectedTab: number = 0;

  // Enrollment-type pill values map to their corresponding selectedTab content block.
  // The 'Enrollments' primary section is considered active for any of these tabs.
  enrollmentTypeTabs: number[] = [1, 3, 4, 5, 6];

  /** True when the active tab is one of the enrollment-type sub-views. */
  get isEnrollmentSection(): boolean {
    return this.enrollmentTypeTabs.includes(this.selectedTab);
  }

  // Track if data has been changed during this session
  private dataHasChanged: boolean = false;
  // Track if this was opened from appointment details
  private openedFromAppointmentDetails: boolean = false;

  openEvent: EventEmitter<void>;

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    // If opened from appointment details and dialog is still open when component is destroyed
    // we need to ensure the data changed flag is passed
    if (this._dialogRef && this.openedFromAppointmentDetails && this.dataHasChanged) {
      // Note: This might not work as expected since the dialog is already closing
      // but we try to update the result
      this._dialogRef.close({ dataChanged: this.dataHasChanged });
    }

    // Clean up tippy instances and subscriptions
    this.destroyTippyInstances();
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  destroyTippyInstances(): void {
    // Iterate over all stored instances and destroy them
    this.tippyInstances.forEach(instance => {
      if (instance && instance.destroy) {
        instance.destroy();
      }
    });

    // Clear the array after destroying the instances
    this.tippyInstances = [];
  }

  override ngAfterViewInit() {
    // this.lessonListRows.paginator = this.paginator;
    // this.lessonListRows.sort = this.sort;
  }

  override ngOnInit(): void {
    // The dialog is opened from many places (student list, calendar views,
    // command palette, appointment details), so access is enforced here
    // rather than at every call site.
    if (!this._permissionsService.canAccess('students_dashboard')) {
      this._snackBar.open('You do not have permission to view the Student Dashboard.', 'Close', { duration: 4000 });
      this._dialogRef?.close();
      return;
    }

    this.subscriptions = [];
    // Exclusive-tax studios see balance/next-payment figures incl. tax in the header.
    // Tracked so ngOnDestroy releases it; mode$ is long-lived and would otherwise
    // keep every closed dashboard in memory.
    this.subscriptions.push(this.studioTaxService.getTaxMode().subscribe(mode => this.taxMode = mode));
    this.showProgressSpinner = true;
    this.openEvent = new EventEmitter<void>();

    // Use the correct property/method for lesson statuses
    this.lessonStatuses = this._taxonomyService.lesson_status;

    this.user = {
      id: this._activatedRoute.snapshot.params['id'] ?? this?._injectedDialogData?.['student_id'] ?? this?._injectedDialogData?.['data']?.['student_id'] ?? '',
    }

    // Check if opened from appointment details
    this.openedFromAppointmentDetails = this?._injectedDialogData?.['openedFromAppointmentDetails'] ||
                                         this?._injectedDialogData?.['data']?.['openedFromAppointmentDetails'] ||
                                         false;
    LoggerService.log('[StudentDashboard] Opened from appointment details:', this.openedFromAppointmentDetails);
    LoggerService.log('[StudentDashboard] Injected data:', this._injectedDialogData);

    // No need for special close handlers since we have a custom close button
    LoggerService.log('[StudentDashboard] Dialog ref exists:', !!this._dialogRef);

    this.loadStudentDashboard();
    this.getLessonList();
    this.getServiceList();
    this.getLegacyData();
    this.getLessonBlockData();
  }

  private loadStudentDashboard() {
    this.studentDashboardObservable = this._utilityService.getLoadStudentDashboard(this.user.id).pipe(
      tap(data => {
        const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        setTimeout(() => {
          window.scrollTo(0, scrollPosition);
        }, 200);

        LoggerService.log("student data", data);
        this.studentAccountID = data['#studentAccountID'][0];

        const studentAccountID = data['#studentAccountID'][0];
        if (studentAccountID) {
          this.getCurrentEnrollment(studentAccountID);
          this.getOverallEnrollmentBalance(studentAccountID);
          this.getNextLessonScheduled(studentAccountID);
          this.getBadgeInfoStudentInfo(studentAccountID);
          this.getEnrollmentTotal(studentAccountID);
          this.getLessonBlockData();
        }

        // Student services DataSource
        if (data['#studentServices']['#rows']) {
          // Convert to iterable array for ngFor directive.
          data['#studentServices']['#rows'] = Object.values(data['#studentServices']['#rows']);
          this.studentServicesColumns = ['date', 'time', 'service', 'length', 'teacher', 'status', 'edit'];
          this.studentServices = data['#studentServices'];
          this.studentServicesRows = data['#studentServices']['#rows'];
        }

        if (data['#enrollment']['#rows']) {
          // Convert to iterable array for ngFor directive.
          data['#enrollment']['#rows'] = Object.entries(data['#enrollment']['#rows']);
        }

        this.studentDashboardData = this.dataSource = data;
        this.showProgressSpinner = false;
      }),
      shareReplay(1)
    );
  }

  getLessonList() {
    this._drupalRESTService.httpGET('/api_rest/v1/getLessonList', [
      { parameter: 'id', value: this.user.id.toString() }
    ]).subscribe(
      (data: any) => {
        this.lessonListColumns = ['date', 'service', 'length', 'teacher', 'status', 'payment_status', 'contacts_present', 'taken / rem', 'edit'];
        this.lessonListRows = new MatTableDataSource(data?.['#student']?.['#rows']?.reverse());
        this.lessonListRows.paginator = this.paginator;
        this.lessonListRows.sort = this.sort;

        this.lessonList2Rows = new MatTableDataSource(data.rows.reverse());
        this.lessonList2Rows.paginator = this.paginator;
        this.lessonList2Rows.sort = this.sort;
      },
      error => {
        LoggerService.error('Error fetching lesson list:', error);
      }
    );
  }

  getServiceList() {
    this._drupalRESTService.httpGET('/api_rest/v1/getServiceList', [
      { parameter: 'id', value: this.user.id.toString() }
    ]).subscribe(
      (data: any) => {
        // Update the service data with the data from the new API
        if (data && data.rows) {
          this.studentServicesColumns = ['date', 'service', 'length', 'teacher', 'status', 'contacts_present', 'edit'];
          this.studentServicesRows = this.formatServiceData(data.rows);
        }
      },
      error => {
        LoggerService.error('Error fetching service list:', error);
      }
    );
  }

  // Helper method to format service data to match the expected format in the template
  formatServiceData(servicesData: any[]) {
    if (!servicesData || !servicesData.length) {
      return [];
    }

    // Transform the data to match the structure expected by the template
    return servicesData.map(service => {
      // Create a row with the expected format
      const row: any = [];

      // Date column
      row[0] = {
        data: service.date_and_time
      };

      // Time column
      row[1] = {
        data: this.reportDateService.formatTime(service.date_and_time)
      };

      // Service column
      row[2] = service.service || 'No Service';

      // Duration column
      row[3] = service.duration || '';

      // Teacher column
      row[4] = service.teacher || '';

      // Status column
      row[5] = {
        data: this.getStatusText(service.status)
      };

      // Add ID for edit functionality
      row.id = service.id;

      return row;
    });
  }

  private getEnrollmentTotal(studentAccountId: string): void {
    const subscription = this._drupalRESTService.httpGET('/api_rest/v1/checkStudentBalanceLimit', [
      { parameter: 'studentAccountId', value: studentAccountId },
      { parameter: 'field_studio_reference_target_id', value: this._authService.selectedStudio?.id }
    ]).subscribe(
      (data) => {
        this.enrollmentBalance = data
      },
      error => {
        LoggerService.error('Error fetching enrollment balance:', error);
      }
    );
    this.subscriptions.push(subscription);
  }

  private getCurrentEnrollment(studentAccountID: string): void {
    const subscription = this._drupalRESTService.httpGET('/api_rest/v1/getCurrentEnrollment', [{ parameter: 'studentAccountID', value: studentAccountID }])
      .subscribe((data) => {
        this.currentEnrollment = data;
        LoggerService.log("currentEnrollment", data);
      }, error => {
        // Handle the error
      });
    this.subscriptions.push(subscription);
  }

  private getOverallEnrollmentBalance(studentAccountID: string): void {
    const clientCurrentDate = new Date().toLocaleString();
    const subscription = this._drupalRESTService.httpGET('/api_rest/v1/getOverallEnrollmentBalance', [
      { parameter: 'studentAccountID', value: studentAccountID },
      { parameter: 'clientCurrentDate', value: clientCurrentDate }
    ]).subscribe((data) => {
      this.overallEnrollmentBalance = data;
    }, error => {
      // Handle the error
    });
    this.subscriptions.push(subscription);
  }

  private getBadgeInfoStudentInfo(studentAccountID: string): void {
    const subscription = this._drupalRESTService.httpGET('/api_rest/v1/getBadgeInfoStudentInfo', [{ parameter: 'studentAccountID', value: studentAccountID }])
      .subscribe((data) => {
        this.studentBadgeInfo = data;
      }, error => {
        // Handle the error
      });
    this.subscriptions.push(subscription);
  }

  private getNextLessonScheduled(studentAccountID: string): void {
    const subscription = this._drupalRESTService.httpGET('/api_rest/v1/getNextLessonScheduled', [{ parameter: 'studentAccountID', value: studentAccountID }])
      .subscribe((data) => {
        this.nextLessonScheduled = data;
      }, error => {
        // Handle the error
      });
    this.subscriptions.push(subscription);
  }

  formatNextLesson(lessonData: any): string {
    if (!lessonData || !lessonData.field_date_and_time || lessonData.field_date_and_time.length === 0) {
      return 'Not available';
    }

    return this.reportDateService.formatDate(lessonData.field_date_and_time[0].value, 'Not available');
  }

  formatDashboardDate(value: string | number | Date | null | undefined, fallback: string = ''): string {
    return this.reportDateService.formatDate(value, fallback);
  }

  formatDashboardDateTime(value: string | number | Date | null | undefined, fallback: string = ''): string {
    return this.reportDateService.formatDateTime(value, fallback);
  }

  getDashboardTimePeriod(value: string | number | Date | null | undefined): string {
    const formattedTime = this.reportDateService.formatTime(value);
    return formattedTime ? formattedTime.split(' ').pop() || '' : '';
  }

  /**
   * Utility to open dialogs with a default configuration.
   *
   * @param formName
   * @param dialogConfig
   */
  openDialog(component: ComponentType<unknown>, dialogConfig: { height: string, width: string, closeOnNavigation?: boolean, data?: {} } = { height: "auto", width: "600px", closeOnNavigation: true }) {
    let dialogRef = this._dialogService.openDialog(component, "defaultWithData", dialogConfig).afterClosed().subscribe(data => {
      // Reload the student dashboard.
      this.loadStudentDashboard();
    });

    this.subscriptions.push(dialogRef);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.lessonListRows.filter = filterValue.trim().toLowerCase();

    if (this.lessonListRows.paginator) {
      this.lessonListRows.paginator.firstPage();
    }
  }

  applyLessonBlockFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.lessonBlockData.filter = filterValue.trim().toLowerCase();

    if (this.lessonBlockData.paginator) {
      this.lessonBlockData.paginator.firstPage();
    }
  }

  printLessonBlocks(): void {
    if (!this.lessonBlockData.data || this.lessonBlockData.data.length === 0) {
      this._snackBar.open('No lesson block data to print', 'Close', { duration: 3000 });
      return;
    }

    const studentName = this.studentDashboardData?.['#studentName'] || 'Student';

    // Generate HTML content for the lesson blocks
    let tableContent = `
      <div class="lesson-blocks-container">
        <div class="report-header">
          <h2>Lesson Blocks Report - ${studentName}</h2>
          <p>Generated on: ${this.reportDateService.formatDate(new Date())}</p>
        </div>

        <table class="lesson-blocks-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Teacher</th>
              <th>Material Covered</th>
              <th>Comments</th>
              <th>Rating</th>
            </tr>
          </thead>
          <tbody>
    `;

    // Add each lesson block as a table row
    for (const lesson of this.lessonBlockData.data) {
      const formattedDate = lesson.date_and_time
        ? this.reportDateService.formatDateTime(lesson.date_and_time, 'No date')
        : 'No date';

      const instructor = lesson.instructor_name || 'No teacher assigned';
      const materialCovered = lesson.material_covered || 'No material covered recorded';
      const comments = lesson.comments || 'No comments recorded';

      // Generate star rating display
      let ratingDisplay = 'No rating';
      if (lesson.lesson_rating && lesson.lesson_rating > 0) {
        let stars = '';
        for (let i = 1; i <= 5; i++) {
          stars += i <= lesson.lesson_rating ? '★' : '☆';
        }
        ratingDisplay = `${stars} (${lesson.lesson_rating}/5)`;
      }

      tableContent += `
        <tr>
          <td>${formattedDate}</td>
          <td>${instructor}</td>
          <td>${materialCovered}</td>
          <td>${comments}</td>
          <td>${ratingDisplay}</td>
        </tr>
      `;
    }

    tableContent += `
          </tbody>
        </table>

        <div class="report-footer">
          <p>Total lesson blocks: ${this.lessonBlockData.data.length}</p>
        </div>
      </div>
    `;

    // Define custom styles for the lesson blocks report
    const styles = `
      @page {
        size: letter portrait;
        margin: 0.75in;
      }

      body {
        font-family: Arial, sans-serif;
        font-size: 12px;
        line-height: 1.4;
        color: #333;
      }

      .lesson-blocks-container {
        width: 100%;
        max-width: 8.5in;
        margin: 0 auto;
      }

      .report-header {
        text-align: center;
        border-bottom: 2px solid #333;
        padding-bottom: 15px;
        margin-bottom: 20px;
        page-break-after: avoid;
      }

      .report-header h2 {
        font-size: 18px;
        font-weight: bold;
        margin: 0 0 10px 0;
        color: #333;
      }

      .report-header p {
        font-size: 12px;
        color: #666;
        margin: 5px 0;
      }

      .lesson-blocks-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
        font-size: 10px;
      }

      .lesson-blocks-table thead {
        display: table-header-group;
      }

      .lesson-blocks-table th {
        background-color: #f8f9fa;
        border: 1px solid #333;
        padding: 8px 6px;
        text-align: left;
        font-weight: bold;
        font-size: 11px;
      }

      .lesson-blocks-table td {
        border: 1px solid #333;
        padding: 8px 6px;
        vertical-align: top;
        font-size: 10px;
        word-wrap: break-word;
      }

      .lesson-blocks-table tr {
        page-break-inside: avoid;
      }

      /* Column widths */
      .lesson-blocks-table th:nth-child(1),
      .lesson-blocks-table td:nth-child(1) { width: 15%; }
      .lesson-blocks-table th:nth-child(2),
      .lesson-blocks-table td:nth-child(2) { width: 15%; }
      .lesson-blocks-table th:nth-child(3),
      .lesson-blocks-table td:nth-child(3) { width: 30%; }
      .lesson-blocks-table th:nth-child(4),
      .lesson-blocks-table td:nth-child(4) { width: 30%; }
      .lesson-blocks-table th:nth-child(5),
      .lesson-blocks-table td:nth-child(5) { width: 10%; text-align: center; }

      .report-footer {
        margin-top: 20px;
        padding-top: 15px;
        border-top: 1px solid #ddd;
        page-break-inside: avoid;
        text-align: center;
        font-size: 11px;
        color: #666;
      }

      /* Ensure proper page breaks */
      .lesson-blocks-table thead tr {
        page-break-after: avoid;
      }

      .lesson-blocks-table tbody tr:nth-child(1),
      .lesson-blocks-table tbody tr:nth-child(2) {
        page-break-before: avoid;
      }

      @media print {
        .lesson-blocks-table thead {
          display: table-header-group;
        }

        .lesson-blocks-table tr {
          page-break-inside: avoid;
        }
      }
    `;

    // Use the PrintService to generate and open the print window
    this.printService.print(tableContent, {
      title: `Lesson Blocks - ${studentName}`,
      styles: styles,
      promptPrint: true,
      showSchoolName: true
    });
  }

  getPreviousURL() {
    // If they came from the same page, just redirect them to students-list page.
    if (this._routeEventsService.previousRoutePath.value.includes("/students")) {
      this.previousUrl = ['/students-list'];
    } else {
      this.previousUrl = [this._routeEventsService.previousRoutePath.value];
    }
    return this.previousUrl;
  }

  initializeTippy(target: HTMLElement): void {
    const tippyInstance = tippy(target, {
      content: this.generatePaymentsDetailsHTML(),
      // Regenerate on each show: the tax mode (and therefore the pre-tax breakdown
      // for exclusive-tax studios) can resolve after the popover was created.
      onShow: (instance) => { instance.setContent(this.generatePaymentsDetailsHTML()); },
      allowHTML: true,
      maxWidth: 520,
      placement: 'bottom',
      theme: 'light',
      // interactive: true,
      // trigger: 'click',
      // animation: 'scale',
      // arrow: true,
      // hideOnClick: true,
    });

    this.tippyInstances.push(tippyInstance);
  }

  /** Studio tax mode (exclusive = tax added on top of prices); null until loaded. */
  taxMode: StudioTaxMode | null = null;

  /** True when the header should add tax to the pre-tax balance figures. */
  get showTaxInclusiveBalances(): boolean {
    return !!this.taxMode?.hasExclusiveTax;
  }

  /** Overall balance due incl. tax (pre-tax + remaining tax) for exclusive-tax studios. */
  get overallBalanceDueWithTax(): number {
    const b = this.overallEnrollmentBalance;
    return (parseFloat(b?.total_balance_due) || 0) + (this.showTaxInclusiveBalances ? (parseFloat(b?.total_balance_due_tax) || 0) : 0);
  }

  /** Next scheduled payment incl. its remaining tax for exclusive-tax studios. */
  get nextPaymentDueWithTax(): number {
    const b = this.overallEnrollmentBalance;
    return (parseFloat(b?.next_payment_amount_due) || 0) + (this.showTaxInclusiveBalances ? (parseFloat(b?.next_payment_amount_due_tax) || 0) : 0);
  }

  generatePaymentsDetailsHTML(): string {
    const b = this.overallEnrollmentBalance;
    const payments: any[] = b?.payments_details || [];
    const fmt = (v: any) => this.currencyService.format(Number(v) || 0);
    // Exclusive-tax studios: the header shows tax-inclusive figures; the pre-tax /
    // tax / total breakdown lives here, as compact tables, so the header stays short.
    const withTax = this.showTaxInclusiveBalances
      && ((parseFloat(b?.total_balance_due_tax) || 0) > 0
        || (parseFloat(b?.next_payment_amount_due_tax) || 0) > 0
        || payments.some(p => (parseFloat(p.tax_amount) || 0) > 0));
    const label = this.taxMode?.label || 'Tax';
    const th = (t: string, align = 'end') => `<th class="text-${align} fw-semibold text-muted small py-1 px-2">${t}</th>`;
    const td = (t: string, align = 'end', extra = '') => `<td class="text-${align} py-1 px-2 text-nowrap ${extra}">${t}</td>`;

    let summaryHTML = '';
    if (withTax) {
      summaryHTML = `<table class="table table-sm table-borderless mb-2 small">
          <thead><tr>${th('', 'start')}${th('Pre-tax')}${th(label)}${th('Total')}</tr></thead>
          <tbody>
            <tr>${td('Overall Balance Due', 'start', 'fw-semibold')}${td(fmt(b.total_balance_due))}${td(fmt(b.total_balance_due_tax))}${td(fmt(this.overallBalanceDueWithTax), 'end', 'fw-semibold')}</tr>
            <tr>${td('Next Payment', 'start', 'fw-semibold')}${td(fmt(b.next_payment_amount_due))}${td(fmt(b.next_payment_amount_due_tax))}${td(fmt(this.nextPaymentDueWithTax), 'end', 'fw-semibold')}</tr>
          </tbody>
        </table>`;
    }

    const rows = payments.map(payment => {
      const formattedDate = this.formatUTCDate(new Date(payment.payment_date));
      const statusText = payment.status.charAt(0).toUpperCase() + payment.status.slice(1).replace('_', ' ');
      const statusClass = payment.status === 'past_due' ? 'text-danger' : 'text-success';
      const amount = Number(payment.payment_amount) || 0;
      const tax = Number(payment.tax_amount) || 0;
      const cells = withTax
        ? `${td(formattedDate, 'start')}${td(fmt(amount))}${td(fmt(tax))}${td(fmt(amount + tax), 'end', 'fw-semibold')}${td(statusText, 'start', statusClass)}`
        : `${td(formattedDate, 'start')}${td(fmt(amount), 'end', 'fw-semibold')}${td(statusText, 'start', statusClass)}`;
      return `<tr>${cells}</tr>`;
    }).join('');

    const head = withTax
      ? `<tr>${th('Payment Date', 'start')}${th('Pre-tax')}${th(label)}${th('Total')}${th('Status', 'start')}</tr>`
      : `<tr>${th('Payment Date', 'start')}${th('Amount')}${th('Status', 'start')}</tr>`;
    const scheduleHTML = payments.length
      ? `<table class="table table-sm mb-0 small"><thead>${head}</thead><tbody>${rows}</tbody></table>`
      : '<div class="small text-muted">No scheduled payments.</div>';

    return `<div class="p-2 text-start">${summaryHTML}${scheduleHTML}</div>`;
  }

  formatUTCDate(date: Date): string {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getUTCDate();
    const monthIndex = date.getUTCMonth();
    const year = date.getUTCFullYear();

    return `${monthNames[monthIndex]} ${day}, ${year}`;
  }

  getLessonStatuses(): void {
    // Fetch the lesson statuses from the _taxonomyService
    this.lessonStatuses = this._taxonomyService.lesson_status;
  }

  getDanceTypeLabel(key: string): string {
    const match = this._fieldsService.dance_types.find(d => d.key === key);
    return match ? match.value : key;
  }

  getStatusText(statusId: string): string {
    // Find the status name based on the status ID
    const status = this._taxonomyService.lesson_status.find(s => s.id === statusId);
    return status ? status.name : 'Pending Status';
  }

  updateStatus(lessonId: number, statusId: string): void {
    // Find the lesson in the lessonList2Rows data source
    const lesson = this.lessonList2Rows.data.find(l => l.id === lessonId);

    if (lesson) {
      // Set the isUpdating flag to true to show the spinner
      lesson.isUpdating = true;

      // Prepare the request parameters
      const params = [
        { parameter: 'selectedStatus[' + lesson.attendees_id + ']', value: statusId },
        { parameter: 'dateTime', value: moment().format('YYYY-MM-DD[T]HH:mm:ss') },
        { parameter: 'eventId', value: lessonId.toString() }
      ];

      const subscription = this._drupalRESTService.httpGET('/api_rest/v1/updateStatus', params)
        .pipe(
          // Process the update response
          tap(data => {
            LoggerService.log('[StudentDashboard] Update status response:', data);
            if (data['success']) {
              // Update the status in the lesson object
              lesson.status = statusId;
              // Mark that data has changed
              this.dataHasChanged = true;
              LoggerService.log('[StudentDashboard] Status updated, dataHasChanged set to:', this.dataHasChanged);
              // Show success message using MatSnackBar
              this._snackBar.open('Status updated successfully', 'Close', {
                duration: 3000,
                panelClass: 'success-snackbar'
              });
              // Refresh the lesson list immediately
              this.getLessonList();
            } else {
              // Show error message using MatSnackBar
              this._snackBar.open('Failed to update status', 'Close', {
                duration: 3000,
                panelClass: 'error-snackbar'
              });
            }
            // Set the isUpdating flag to false to hide the spinner
            lesson.isUpdating = false;
          }),
          // Add a small delay to ensure backend has fully processed
          delay(500),
          // Only continue if the update was successful
          switchMap(data => {
            if (data['success']) {
              LoggerService.log('[StudentDashboard] Fetching fresh dashboard data after status update');
              // Return the dashboard refresh observable
              return this._utilityService.getLoadStudentDashboard(this.user.id);
            } else {
              // Don't refresh if update failed
              return of(null);
            }
          })
        )
        .subscribe(
          dashboardData => {
            if (dashboardData && this.studentDashboardData) {
              LoggerService.log('[StudentDashboard] Updating dashboard with fresh data after status change');
              // Update the summary values with the fresh data
              this.studentDashboardData['#totalLessonsEnrolled'] = dashboardData['#totalLessonsEnrolled'];
              this.studentDashboardData['#totalLessonsTaken'] = dashboardData['#totalLessonsTaken'];
              this.studentDashboardData['#totalLessonsRemaining'] = dashboardData['#totalLessonsRemaining'];
              this.studentDashboardData['#totalLessonsPaidAhead'] = dashboardData['#totalLessonsPaidAhead'];
              this.studentDashboardData['#totalFutureLessons'] = dashboardData['#totalFutureLessons'];

              // Also refresh the auxiliary data
              if (this.studentAccountID) {
                this.getCurrentEnrollment(this.studentAccountID);
                this.getOverallEnrollmentBalance(this.studentAccountID);
                this.getNextLessonScheduled(this.studentAccountID);
                this.getBadgeInfoStudentInfo(this.studentAccountID);
                this.getEnrollmentTotal(this.studentAccountID);
              }
            }
          },
          error => {
            LoggerService.error('Error updating status:', error);
            // Set the isUpdating flag to false to hide the spinner
            lesson.isUpdating = false;

            // Handle specific error status codes
            if (error.status === 406) {
              // Show error message using MatSnackBar
              this._snackBar.open(error?.error?.message || 'No lessons available for this enrollment', 'Close', {
                duration: 3000,
                panelClass: 'error-snackbar'
              });
            } else {
              // Show generic error message using MatSnackBar
              this._snackBar.open('An error occurred while updating the status', 'Close', {
                duration: 3000,
                panelClass: 'error-snackbar'
              });
            }
          }
        );
      this.subscriptions.push(subscription);
    }
  }

  getPaymentStatusLabel(status: string): string {
    switch (status) {
      case 'paid': return 'Paid';
      case 'unpaid': return 'Unpaid';
      case 'partially_paid': return 'Partially Paid';
      case 'paid_ahead': return 'Paid Ahead';
      default: return '';
    }
  }

  getStatusClass(statusId: string): string {
    switch (statusId) {
      case '63':
        return 'amt-bg-gray badge';
      case '61':
        return 'amt-bg-gray badge';
      case '60':
        return 'amt-bg-canceled-too-late badge';
      case '1425':
        return 'amt-bg-canceled-too-late badge';
      case '64':
        return 'amt-bg-red badge';
      case '62':
        return 'amt-bg-purple badge';
      case '59':
        return 'amt-bg-green badge';
      case '':
        return 'amt-bg-red badge';
      default:
        return 'amt-bg-red badge';
    }
  }

  override openEntityComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}, callback?: () => void) {
    LoggerService.log('fieldsData', fieldsData)
    LoggerService.log('action', action)
    this._dialogService.openDialog(component, "defaultWithData", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
        callback: callback
      },
    }).afterClosed().subscribe(data => {
      // Refresh the student dashboard.
      this.loadStudentDashboard();
    });
  }

  // Special method for service edits that only refreshes the service list
  openServiceEditComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}, callback?: () => void) {
    const dialogRef = this._dialogService.openDialog(component, "defaultWithData", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
        callback: callback
      },
    }).afterClosed().subscribe(data => {
      // Only refresh the service list data without showing the loading indicator
      this.getServiceList();
    });

    // Add to subscriptions for proper cleanup
    this.subscriptions.push(dialogRef);
  }

  // Special method for lesson edits that refreshes lesson list and dashboard data
  openLessonEditComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}, callback?: () => void) {
    const dialogRef = this._dialogService.openDialog(component, "defaultWithData", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
        callback: callback
      },
    }).afterClosed().subscribe(data => {
      // Refresh the lesson list
      this.getLessonList();

      // Also refresh dashboard data (summary statistics, balance, etc.)
      this.refreshDashboardData();
    });

    // Add to subscriptions for proper cleanup
    this.subscriptions.push(dialogRef);
  }

  // Special method for enrollment edits that refreshes all relevant dashboard data
  openEnrollmentEditComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}, callback?: () => void) {
    const dialogRef = this._dialogService.openDialog(component, "defaultWithData", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(result => {
      // Enrollments affect many things, so refresh comprehensively
      this.getLessonList();
      this.getServiceList();
      this.refreshDashboardData();
      this.getLessonBlockData();

      // Call the callback to refresh the child component's data (e.g., lesson-student-report)
      if (callback) {
        callback();
      }
    });

    // Add to subscriptions for proper cleanup
    this.subscriptions.push(dialogRef);
  }

  getLegacyData() {
    this._drupalRESTService.httpGET('/api_rest/v1/getLegacyData', [
      { parameter: 'id', value: this.user.id.toString() }
    ]).subscribe(
      (data: any) => {
        if (data && data.success) {
          this.legacyData = data;
        } else {
          LoggerService.warn('Legacy data not available or error occurred:', data);
          // Initialize with empty data to prevent template errors
          this.legacyData = {
            enrollments: [],
            payments: [],
            lessons: []
          };
        }
      },
      error => {
        LoggerService.error('Error fetching legacy data:', error);
        // Initialize with empty data to prevent template errors
        this.legacyData = {
          enrollments: [],
          payments: [],
          lessons: []
        };
      }
    );
  }

  getLessonBlockData(page: number = 0, append: boolean = false) {
    if (!this.studentAccountID) {
      // If studentAccountID is not available yet, we'll call this method again after it's loaded
      return;
    }

    this._drupalRESTService.httpGET('/api_rest/v1/getStudentLessonBlockData', [
      { parameter: 'studentAccountId', value: this.studentAccountID },
      { parameter: 'page', value: page.toString() },
      { parameter: 'limit', value: this.lessonBlockPageSize.toString() },
      { parameter: 'startFromComment', value: this.lessonBlockStartFromComment.toString() }
    ]).subscribe(
      (data: any) => {
        if (data && data.success && data.data) {
          if (append) {
            // Append new data to existing data
            const currentData = this.lessonBlockData.data;
            this.lessonBlockData = new MatTableDataSource([...currentData, ...data.data]);
          } else {
            // Replace data
            this.lessonBlockData = new MatTableDataSource(data.data);
          }

          this.lessonBlockCurrentPage = data.currentPage || page;
          this.lessonBlockTotalCount = data.totalCount || 0;
          this.lessonBlockHasMore = data.hasMore || false;

          LoggerService.log('Lesson block data loaded:', {
            pageData: data.data.length,
            totalCount: this.lessonBlockTotalCount,
            hasMore: this.lessonBlockHasMore,
            currentPage: this.lessonBlockCurrentPage
          });
        } else {
          LoggerService.warn('Lesson block data not available or error occurred:', data);
          if (!append) {
            this.lessonBlockData = new MatTableDataSource([]);
            this.lessonBlockTotalCount = 0;
            this.lessonBlockHasMore = false;
          }
        }
      },
      error => {
        LoggerService.error('Error fetching lesson block data:', error);
        if (!append) {
          this.lessonBlockData = new MatTableDataSource([]);
          this.lessonBlockTotalCount = 0;
          this.lessonBlockHasMore = false;
        }
      }
    );
  }

  loadMoreLessonBlocks() {
    if (this.lessonBlockHasMore) {
      const nextPage = this.lessonBlockCurrentPage + 1;
      this.getLessonBlockData(nextPage, true);
    }
  }

  toggleLessonBlockFilter() {
    this.lessonBlockStartFromComment = !this.lessonBlockStartFromComment;
    this.lessonBlockCurrentPage = 0;
    this.getLessonBlockData(0, false);
  }

  /**
   * Refreshes the dashboard data when child components update
   * This is called when payments or enrollments are saved
   */
  refreshDashboardData(): void {
    // Mark that data has changed
    this.dataHasChanged = true;

    // Only refresh the summary statistics, not reload child components
    if (!this.studentAccountID) {
      return;
    }

    // Refresh the auxiliary data
    this.getCurrentEnrollment(this.studentAccountID);
    this.getOverallEnrollmentBalance(this.studentAccountID);
    this.getNextLessonScheduled(this.studentAccountID);
    this.getBadgeInfoStudentInfo(this.studentAccountID);
    this.getEnrollmentTotal(this.studentAccountID);

    // Refresh payment list
    if (this.paymentReportsComponent) {
      this.paymentReportsComponent.getData([]);
    }

    // Refresh only the summary statistics from the dashboard
    const subscription = this._utilityService.getLoadStudentDashboard(this.user.id).subscribe(data => {
      if (data && this.studentDashboardData) {
        // Update only the summary values without triggering a full reload
        this.studentDashboardData['#totalLessonsEnrolled'] = data['#totalLessonsEnrolled'];
        this.studentDashboardData['#totalLessonsTaken'] = data['#totalLessonsTaken'];
        this.studentDashboardData['#totalLessonsRemaining'] = data['#totalLessonsRemaining'];
        this.studentDashboardData['#totalLessonsPaidAhead'] = data['#totalLessonsPaidAhead'];
        this.studentDashboardData['#totalFutureLessons'] = data['#totalFutureLessons'];
      }
    });

    // Add to subscriptions for cleanup
    this.subscriptions.push(subscription);
  }

  /**
   * Override closeDialog to pass dataChanged flag when closing (only if opened from appointment details)
   */
  override closeDialog(data?: any): void {
    // Only pass the dataChanged flag if opened from appointment details
    const closeData = data || {};
    if (this.openedFromAppointmentDetails) {
      closeData.dataChanged = this.dataHasChanged;
      LoggerService.log('[StudentDashboard] Closing with dataChanged:', closeData.dataChanged);
    }
    super.closeDialog(closeData);
  }

  /**
   * Custom close method for the X button to ensure dataChanged flag is passed
   */
  closeDialogWithData(): void {
    LoggerService.log('[StudentDashboard] Close button clicked, dataHasChanged:', this.dataHasChanged);
    if (this.openedFromAppointmentDetails) {
      this._dialogRef.close({ dataChanged: this.dataHasChanged });
    } else {
      this._dialogRef.close();
    }
  }

  /**
   * Opens the department dialog to allow manual department override
   */
  openDepartmentDialog(): void {
    const dialogRef = this._dialogService.openDialog(StudentDepartmentComponent, "defaultWithData", {
      data: {
        student_account_id: this.studentAccountID,
        current_department: this.studentBadgeInfo?.['department']
      },
      width: '450px'
    });

    const subscription = dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.updated) {
        // Refresh badge info after department change
        this.getBadgeInfoStudentInfo(this.studentAccountID);
        this.dataHasChanged = true;
      }
    });

    this.subscriptions.push(subscription);
  }

}
